module.exports = __webpack_public_path__ + "static/media/training-successful.e00c88f8.png";